module.exports = __webpack_public_path__ + "img/p5.c44fdcdb.png";